import { toTimestamp } from "..";
import { CSSEvent, TimeSlot } from "../../types/model";

function getNextTimeSlot(timeSlots: TimeSlot[]) {
  const slots = timeSlots
    .filter((s) => toTimestamp(s.utcStartDate) > Date.now())
    .sort((a, b) => {
      if (toTimestamp(a.utcStartDate) > toTimestamp(b.utcStartDate)) {
        return 1;
      } else if (toTimestamp(a.utcStartDate) < toTimestamp(b.utcStartDate)) {
        return -1;
      } else {
        return 0;
      }
    });

  return slots[0];
}

export default function sortEventsByStartDate(a: CSSEvent, b: CSSEvent) {
  const aTimeSlot = getNextTimeSlot(a.timeSlots);
  const bTimeSlot = getNextTimeSlot(b.timeSlots);

  if (aTimeSlot?.utcStartDate && bTimeSlot?.utcStartDate) {
    if (toTimestamp(aTimeSlot?.utcStartDate) > toTimestamp(bTimeSlot?.utcStartDate)) {
      return 1;
    } else if (
      toTimestamp(aTimeSlot?.utcStartDate) < toTimestamp(bTimeSlot?.utcStartDate)
    ) {
      return -1;
    } else {
      return 0;
    }
  } else {
    return 0;
  }
}
